// extracted by mini-css-extract-plugin
export default {"main":"Customer_main__i6UGH"};